import React, { useEffect, useState, useCallback } from 'react';
import DataTable from './DataTable';
import axiosInstance from '../utils/axiosInstance';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const RejectedRequests = () => {
  const [data,    setData]    = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchRejectedRequests = useCallback(async () => {
    try {
      const response = await axiosInstance.get('/request/rejected');
      setData(
        response.data
          .filter(r => r.status === 'rejected')
          .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
      );
    } catch (e) { console.error(e); }
    finally { setLoading(false); }
  }, []);

  useEffect(() => { fetchRejectedRequests(); }, [fetchRejectedRequests]);

  if (loading) return (
    <div style={{ minHeight: '100vh', background: '#090a0c', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'rgba(255,255,255,.25)', fontFamily: 'Inter,sans-serif', fontSize: '.85rem' }}>
      Yükleniyor...
    </div>
  );

  return (
    <>
      <ToastContainer theme="dark" position="top-right" autoClose={2000} limit={3} />
      <DataTable
        title="Reddedilen Talepler"
        data={data}
        isPendingPage={false}
        fetchData={fetchRejectedRequests}
      />
    </>
  );
};

export default RejectedRequests;
